import { GLTFLoader } from 'Application/FileLoader/GLTFLoader';

/*****************************************************************
 *  Mesh Provider
 * ***************************************************************/

const gltfLoader = new GLTFLoader()

/**
 * Provide Gltf file Assets
 * @param {*} model 
 */
export const getJaw = model => {

    let blobUrl = null;

    const getmodelurl = model => new Promise( resolve => {
        if (model instanceof Blob) {
            blobUrl = URL.createObjectURL(model);
            resolve(blobUrl);
        }
    });

    return getmodelurl(model).then( url => 
        new Promise((resolve, reject) => {
            gltfLoader.load( 
                url, 
                gltf => {
                    if (blobUrl) {
                        URL.revokeObjectURL(blobUrl);
                        blobUrl = null;
                    }
                    resolve(gltf);
                }, 
                null, 
                error => {
                    if (blobUrl) {
                        URL.revokeObjectURL(blobUrl);
                        blobUrl = null;
                    }
                    console.error( error );
                    reject(error);
                }
            );
        })
    );
}
